import React from 'react';
import './TestimonialSection2.css';
import client1 from "../../../assets/images/dummy_founder_1.jpg";
import client2 from "../../../assets/images/dummy_lead_3.jpg";
import client3 from "../../../assets/images/dummy_manager2.jpg";

const testimonials = [
  {
    name: "Amit Sharma",
    location: "Delhi, India",
    feedback: "I had a fantastic experience with their packing and moving service. Everything arrived on time and in perfect condition.",
    rating: 5,
    image: client1,
  },
  {
    name: "Neha Gupta",
    location: "Mumbai, India",
    feedback: "Professional and reliable service! The team handled my belongings with utmost care. Highly recommend them!",
    rating: 4,
    image: client2,
  },
  {
    name: "Rajesh Kumar",
    location: "Bangalore, India",
    feedback: "Amazing experience! The team was punctual and the packaging was excellent. I’ll use their services again.",
    rating: 5,
    image: client3,
  },
];

export default function TestimonialSection2() {
  return (
    <section className="testimonials_jj2">
      <h2 className="testimonials-heading_jj2">What Our Clients Say</h2>
      <div className="carousel_jj2">
        {testimonials.map((testimonial, index) => (
          <div className="carousel-card_jj2" key={index}>
            <div className="card-inner_jj2">
              <div className="card-front_jj2">
                <div className="image-container_jj2">
                  <img src={testimonial.image} alt={testimonial.name} />
                </div>
                <h4 className="testimonial-name_jj2">{testimonial.name}</h4>
                <p className="testimonial-location_jj2">{testimonial.location}</p>
              </div>
              <div className="card-back_jj2">
                <p className="testimonial-feedback_jj2">"{testimonial.feedback}"</p>
                <div className="testimonial-rating_jj2">
                  {"★".repeat(testimonial.rating)}{"☆".repeat(5 - testimonial.rating)}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
